export default class CtaButton {
    static BTN_CLASS = '.js-cta-btn'
    static CK_LEFT_BTN_CLASS = '.js-ck-btn-left'
    static CK_RIGHT_BTN_CLASS = '.js-ck-btn-right'

    constructor() {
        const backend = document.querySelectorAll('.neos-backend')
        this.ckLeftArrowBtns = document.querySelectorAll(CtaButton.CK_LEFT_BTN_CLASS)
        this.ckRightArrowBtns = document.querySelectorAll(CtaButton.CK_RIGHT_BTN_CLASS)

        if (!backend.length) {
            this.mutateCkButtons()
        }

        this.btns = document.querySelectorAll(CtaButton.BTN_CLASS)
        this.addBtnListener()
    }

    mutateCkButtons() {
        this.ckLeftArrowBtns.forEach((btn) => {
            btn.classList.remove('js-ck-btn-left')
            let btnClasses = btn.classList.toString()

            btn.classList = 'btn button-text--primary cta-button'
            const html = `
              <div class="${btnClasses}"></div>
              ${btn.outerHTML}
            `

            var cta = document.createElement('div')
            cta.classList = 'btn-wrapper js-cta-btn btn-inline'
            cta.innerHTML = html
            btn.replaceWith(cta)
        })

        this.ckRightArrowBtns.forEach((btn) => {
            btn.classList.remove('js-ck-btn-right')
            let btnClasses = btn.classList.toString()

            btn.classList = 'btn button-text--primary cta-button'
            const html = `
              ${btn.outerHTML}
              <div class="${btnClasses}"></div>
            `
            var cta = document.createElement('div')
            cta.classList = 'btn-wrapper js-cta-btn btn-inline'
            cta.innerHTML = html
            btn.replaceWith(cta)
        })
    }

    addBtnListener() {
        this.btns.forEach((btn) => CtaButton.addIconFadeAnimations(btn))
    }

    static addIconFadeAnimations(btn) {
        btn.addEventListener('mouseover', () => {
            btn.classList.remove('btn--icon-fade-out-animation')
            btn.classList.add('btn--icon-fade-in-animation')
        })
        btn.addEventListener('mouseout', () => {
            btn.classList.add('btn--icon-fade-out-animation')
            btn.classList.remove('btn--icon-fade-in-animation')
        })
    }
}
